module.exports = __webpack_public_path__ + "img/latvia.b8a7fc82.svg";